var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg60Kstudentrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m395.24 175.667c.738 19.881 29.269 19.866 30 0v-61.844l-30 10.965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.607 85.481 154.189 56.395c3.327 1.217 6.974 1.217 10.302.002l154.292-56.395c13.05-4.755 13.045-23.425.001-28.177l-154.241-56.393c-3.326-1.217-6.975-1.217-10.301 0l-154.24 56.393c-13.048 4.754-13.043 23.423-.002 28.175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.64 327.227c0-28.055-22.825-50.88-50.88-50.88-67.407 2.558-67.388 99.212.001 101.76 28.054 0 50.879-22.825 50.879-50.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.121 327.227c0-28.055-22.825-50.88-50.88-50.88-67.407 2.558-67.388 99.212.001 101.76 28.054 0 50.879-22.825 50.879-50.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.12 327.227c0 28.055 22.825 50.88 50.88 50.88 67.407-2.558 67.389-99.212-.001-101.76-28.054 0-50.879 22.825-50.879 50.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.24 378.107c-20.089 0-38.836 5.853-54.628 15.941 19.962 23.072 32.045 53.067 32.045 85.818v32.134h109.343c8.284 0 15-6.716 15-15v-17.134c0-56.11-45.649-101.759-101.76-101.759z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.147 378.107c-56.524 0-102.51 45.649-102.51 101.76v32.133h205.021v-32.134c-.001-56.11-45.987-101.759-102.511-101.759z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.76 378.107c-56.111 0-101.76 45.649-101.76 101.759v17.134c0 8.284 6.716 15 15 15h107.637v-32.134c0-33.078 12.326-63.346 32.646-86.509-15.559-9.661-33.9-15.25-53.523-15.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.333 194.49v-53.653l-79.936 29.217c-9.904 3.645-21.021 3.645-30.917-.009l-79.813-29.191v53.652c0 6.298 3.934 11.925 9.848 14.087l80.282 29.362c3.326 1.216 6.975 1.216 10.301.001l80.384-29.377c5.915-2.162 9.851-7.79 9.851-14.089z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg60Kstudentrs);
export default __webpack_public_path__ + "static/media/60K studentrs.46a06fdff8daab4295581d8ed61ab02b.svg";
export { ForwardRef as ReactComponent };